// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__3pdzp","footer":"ModalError_footer__2EPZI"};